export default "__VITE_ASSET__Dw1Qu4DX__"